module.exports = __webpack_public_path__ + "files/da567a040fce78823cbed637e7044d16.png";